export const ENTITIES_URL = '/admin/v2/entities';
export const SUPER_ADMIN_URL = '/admin/v2/superadmins';
